// extracted by mini-css-extract-plugin
module.exports = {"children_wrapper":"style_children_wrapper__gwZgC","main_wrapper":"style_main_wrapper__e3sDy"};